"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var logOrThrowError_1 = require("../lib/logOrThrowError");
var Item = function () {
    logOrThrowError_1.default('AccordionItem should not be rendered, but consumed by Accordion instead.');
    return null;
};
Item.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired
};
exports.default = Item;
//# sourceMappingURL=Item.js.map